import { useSearchParams } from 'react-router-dom'

export function useProject(): string | null {
  const [searchParams] = useSearchParams()
  return searchParams.get('project')
}
